import React, {useState} from 'react';
import "./MessageSender.css";
import { Avatar , Button } from '@material-ui/core';
import VideocamIcon from '@material-ui/icons/Videocam';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import { useStateValue } from "./StateProvider";
import db from "./firebase";
import firebase from "firebase";
import { storage } from "./firebase";
import CloseIcon from '@material-ui/icons/Close';

function MessageSender() {
    const [{user}, dispatch] = useStateValue();
    const [input, setInput] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [url, setUrl] = useState('');
    const handleChange = e => {
        if(e.target.files[0]) {
            setImageUrl(e.target.files[0]);
        }
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        if(!imageUrl) {
            db.collection('posts').add({
                message: input,
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                profilePic: user.photoURL, 
                username: user.displayName,
            })
        } else {
        const uploadTask = storage.ref(`images/${imageUrl.name}`).put(imageUrl);
        uploadTask.on (
            "state_changed",
            snapshot => {},
            error => {
                console.log(error);
            },
            () => {
                storage
                .ref("images")
                .child(imageUrl.name)
                .getDownloadURL()
                .then(url => {
                    db.collection('posts').add({
                        message: input,
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                        profilePic: user.photoURL, 
                        username: user.displayName,
                        image:url,
                    })
                    setUrl(url);
                });
            }
        )
        }
        /*
        db.collection('posts').add({
            message: input,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            profilePic: user.photoURL, 
            username: user.displayName,
        })
        */
        setInput('');
        setImageUrl('');
        setSinput(!sinput);
    }
    
    const [sinput, setSinput] = useState(false);
    const showInput = () => setSinput(!sinput);
    const showForm = () => setSinput(false);

    return (
        <div className="messageSender">
        
            <div className="messageSender__top">
                <Avatar src={user.photoURL}/>
                <Button onClick={showInput} className="showIn">What's on your mind, {user.displayName}?</Button>
            </div>
            <div className={sinput? 'stop__second' : 'messageSender__top top__second'}>
                <form>
                    <CloseIcon className="close__icon" onClick={showForm}/>
                    <input 
                    value={input}
                    onChange={event => setInput(event.target.value)}
                    className="messageSender__input"
                    type="text" 
                    placeholder={`What's on your mind, ${user.displayName}?`}
                    />
                    <input type="file"
                    onChange={handleChange}
                    />
                    <Button onClick={handleSubmit} className = "postIn"
                        disabled = {!input}
                        type="submit">
                        Post
                    </Button>
                </form>
            </div>
            <div className="messageSender__bottom">
                <div className="messageSender__option">
                    <VideocamIcon style={{color:"red"}} />
                    <h3>Live Video</h3>
                </div>
                <div className="messageSender__option">
                    <PhotoLibraryIcon style={{color:"green"}} />
                    <h3>Photo/Video</h3>
                </div>
                <div className="messageSender__option reduce__option">
                    <InsertEmoticonIcon style={{color:"orange"}} />
                    <h3>Feeling/Activity</h3>
                </div>
            </div>
            
        </div>
    )
}

export default MessageSender


//https://facebook-clone-2428e.web.app/